import { createComponent } from "../utils";

export default createComponent({
  name: "Center Point",
  group: "Surface",
  icon: () => (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 428 428"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M178.48 249.52V178.481H249.519V249.52H178.48Z"
        fill="currentColor"
      />
      <path
        d="M0.890137 427.11H427.11V0.890137H0.890137V427.11ZM15.0971 412.903V15.0931H412.907V412.903H15.0971Z"
        fill="currentColor"
      />
    </svg>
  ),
  controls: [],
  inputs: [
    {
      id: "geometry",
      name: "Brep",
      type: "Brep",
    },
  ],
  outputs: [
    {
      id: "center",
      name: "Center",
      type: "Point",
      compute: ({ geometry }) => {
        if (geometry) {
          const boundingBox = geometry.getBoundingBox();
          return new window.rhino.Point(boundingBox.center);
        }
      },
    },
  ],
});
